"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListBulletedOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<g stroke="none"><path d="M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path><path d="M27.105 8h-15.21C11.358 8 11 7.6 11 7s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1z"></path><path d="M27.105 17h-15.21c-.537 0-.895-.4-.895-1s.358-1 .895-1h15.21c.537 0 .895.4.895 1s-.447 1-.895 1z"></path><path d="M11.895 26h15.21c.448 0 .895-.4.895-1s-.358-1-.895-1h-15.21c-.537 0-.895.4-.895 1s.358 1 .895 1z"></path><path d="M8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0z"></path><path d="M6 27a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path></g>';
var ListBulletedOutlineSVG = function ListBulletedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ListBulletedOutlineSVG = ListBulletedOutlineSVG;
ListBulletedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ListBulletedOutlineSVG);
exports.default = _default;